import React from 'react';
import TemplateInformPage from "../../../../Components/TemplateInformPage";
import {Localization} from "../../../../Common/Localization";
import { ReactComponent as AlertIcon} from "../../../../Resources/alert-triangle.svg";
import {config} from "../../../../Config/Config";



const styles = {
    container: {
        display: 'flex',
        flexDirection: 'column',
        position: 'relative',
        width: '100%',
        height: '100%',
        justifyContent: 'center',
    },
    alignCenter: {
        alignSelf: 'center'
    }
};

const iconStroke = config.theme.iconColor || "#368FBB";
const iconFill= config.theme.iconFill || "#EBF4F8";

function ChangeEmailExpirePage() {
    return (
        <div style={{...styles.container}}>
            <div style={{...styles.alignCenter}}>
                <AlertIcon  stroke={iconStroke} fill={iconFill}/>
            </div>
            <TemplateInformPage
                title={Localization.VERIFY_PAGE.TOKEN_EXPIRED.TITLE}
                text={Localization.VERIFY_PAGE.TOKEN_EXPIRED.MESSAGE}
            />
            <div style={{height: 50}}></div>

        </div>
    );
}

export default ChangeEmailExpirePage;
